import { Message, MessageSeverity } from "../../../createOrderTypes"

export const getTopPriorityMessage = (messages: Message[]): Message | null => {
    const priorities = [MessageSeverity.ERROR, MessageSeverity.WARNING, MessageSeverity.INFO, MessageSeverity.SUCCESS]
    for (const p of priorities) {
        const found = messages.find((msg) => msg.severity === p)
        if (found) return found
    }
    return null
}
